<template >
  <div class="">
		<b-modal id="success-modal" v-model="messageSent" centered title="BootstrapVue">
			<p class="my-4" style="padding-left:20px;">Message Sent</p>
		</b-modal>
    <b-modal id="ModalFiber" class="modal-box" centered size="lg" ok-only>
      <b-row>
        <b-col lg="5" md="12" class="logo">
          <img :src="fiberDetail.logo" alt="company_name" />
          <div class="share-box desktop-only">
            <span>Share this {{fiberDetail.type == 'vendor' ? 'vendor' : 'shipyard' }} :</span>
            <ul>
              <li><a @click="PopupCenter('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), `Share this ${fiberDetail.type == 'vendor' ? 'vendor' : 'shipyard'} on Facebook`)" class="fb"></a></li>
              <li><a @click="PopupCenter('https://twitter.com/intent/tweet?url=' + url,'Share to Twitter',undefined,253)" href="#" class="twitter"></a></li>
              <li><a :href="'mailto:' + fiberDetail.email + '?subject=Check ' + fiberDetail.name + ' on docking.id'" class="email"></a></li>
            </ul>
          </div>
        </b-col>
        <b-col lg="7" md="12">
          <h2 class="company-name">{{fiberDetail.name}}</h2>
          <div class="company-location">
            <span class="city">City : {{fiberDetail.city && fiberDetail.city.name}}</span>
            <span class="longlat">long : {{fiberDetail.city && fiberDetail.city.long}} - lat : {{fiberDetail.city && fiberDetail.city.lat}}</span>
          </div>
          <b-row class="contact-list">
            <b-col class="label" sm="6" cols="4" lg="4">
              Phone
            </b-col>
            <b-col class="content" sm="6" cols="8" lg="8">
               : {{fiberDetail.phone}}
            </b-col>
          </b-row>

          <b-row class="contact-list">
            <b-col class="label" sm="6" cols="4" lg="4" >
              Email
            </b-col>
            <b-col class="content" sm="6" cols="8" lg="8" >
               : {{fiberDetail.email}}
            </b-col>
          </b-row>

          <b-row v-if="!hideMessageForm">
            <a name="button" class="btn-primary kirim-pesan" v-b-modal.modalMessageShipyard>Contact {{fiberDetail.name}}</a>
          </b-row>

          <div class="share-box mobile-only">
            <span>Share this {{fiberDetail.type == 'vendor' ? 'vendor' : 'shipyard' }} :</span>
            <ul>
              <li><a @click="PopupCenter('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), `Share this ${fiberDetail.type == 'vendor' ? 'vendor' : 'shipyard'} on Facebook`)" class="fb"></a></li>
              <li><a @click="PopupCenter('https://twitter.com/intent/tweet?url=' + url,'Share to Twitter',undefined,253)" href="#" class="twitter"></a></li>
              <li><a :href="'mailto:' + fiberDetail.email + '?subject=Check ' + fiberDetail.name + ' on docking.id'" class="email"></a></li>
            </ul>
          </div>
        </b-col>
      </b-row>
      <ModalMessageShipyard v-if="!hideMessageForm" :shipyard="shipyard" @onMessageSent="onMessageSent"/>
    </b-modal>
  </div>
</template>

<script>

import ModalMessageShipyard from '~/components/modal/shipyard-message-form'

export default {
  components: {
    ModalMessageShipyard
  },
  props: ['fiberDetail', 'hideMessageForm'],
  data() {
    return {
      url: 'https://docking.id/galangan',
      messageSent: false
    }
  },
  methods: {
    onMessageSent() {
      this.messageSent = true;
    },
    PopupCenter(url, title, w, h) {
      var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
      var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

      var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

      var left = ((width / 2) - (w / 2)) + dualScreenLeft;
      var top = ((height / 2) - (h / 2)) + dualScreenTop;
      var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

      if (window.focus) {
        newWindow.focus();
      }
    }
  }
}
</script>

<style lang="scss">
	@import '~/assets/scss/_mixins.scss';
	@import './style.scss';
</style>
